import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import swal from 'sweetalert2';
import DateTime from '_class/DateTime';
import { setPageTitle } from 'actions/header';
import { addError } from 'actions/index';
import { deletePlan, getPlanDetails, setActivePlan, getPlanSection } from 'actions/plans';
import { fetch_preschoolgoals } from 'actions/preschoolform';
import { getReaderParameters } from 'actions/user';
import { getBlocksByReference, clearBlocksOnReference } from 'actions/blocks';
import { getRootUrl } from 'helpers/url';
import { isUserStudent } from 'helpers/user';
import { getImmersiveReaderDataFromBlocks } from 'helpers/content';
import { trackImmersiveReaderError } from 'helpers/insights';
import UserPlanning from 'components/List/UserPlanning';
import DateSpan from 'components/Presentation/Date/DateSpan';
import PostContent from 'components/Presentation/PostContent';
import PreschoolPlanningForm from 'containers/Forms/PlanningForm/PreschoolPlanningForm';
import Modal from 'containers/Modals/Modal';
import PlanPosts from '../Functionality/PlanPosts';
import TeacherAdjustments from "containers/AdditionalAdjustments/Display/TeacherAdjustments";
import Bookmark from 'containers/SinglePages/Partials/Bookmark';
import CloneButton from "containers/SinglePages/Partials/CloneButton";
import BlockConsumer from 'components/BlockEditor/Consumer';
import { List, Spinner, Collapsible, Expandable } from 'UI';
import { Immersive_Reader } from 'UI/Icons';
import { Button, Block, Icon } from '@haldor/ui';

var ImmersiveReader = require('@microsoft/immersive-reader-sdk');

var PreschoolPlan = /*#__PURE__*/function (_Component) {
  _inherits(PreschoolPlan, _Component);

  var _super = _createSuper(PreschoolPlan);

  function PreschoolPlan(props) {
    var _this;

    _classCallCheck(this, PreschoolPlan);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var planId = _this.props.match.params.planId;

      if (planId > 0) {
        _this.reload();
      }

      if (_this.props.goals.length < 1) {
        _this.props.fetch_preschoolgoals();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      ImmersiveReader.close();

      _this.props.clearBlocksOnReference();
    });

    _defineProperty(_assertThisInitialized(_this), "reload", function () {
      _this.setState({
        loading: true,
        loadingBlocks: true
      });

      _this.props.getPlanDetails(_this.props.match.params.planId).then(function () {
        _this.setState({
          loading: false
        });

        if (_this.props.plan == null || _this.props.plan === "") {
          return false;
        }

        _this.props.setPageTitle(_this.props.plan.title);

        _this.props.getPlanSection(_this.props.plan.sectionId);

        _this.props.getBlocksByReference(_this.props.match.params.planId, 'PLAN').then(function () {
          _this.setState({
            loadingBlocks: false
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDeletion", function () {
      swal.fire({
        title: _this.props.translate('Delete'),
        text: _this.props.translate('delete-plan-prompt'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Delete')
      }).then(function (result) {
        if (result.value != null) {
          _this.props.deletePlan(_this.props.match.params.planId).then(function () {
            _this.props.history.push(getRootUrl());
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "runImmersiveReader", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, plan, currentUser, localLanguage, reader, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, plan = _this$props.plan, currentUser = _this$props.currentUser;
              localLanguage = localStorage.getItem('language');
              console.log('run Microsoft Immersive Reader', localLanguage, currentUser.id);
              _context.next = 5;
              return _this.props.getReaderParameters();

            case 5:
              reader = _this.props.reader;
              data = getImmersiveReaderDataFromBlocks(plan.title, _this.props.blocks);
              ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                uiLang: localLanguage // Set immersive reader UI language to selected lang in Haldor Edu

              })["catch"](function (error) {
                console.error('error', error);
                trackImmersiveReaderError(error, currentUser.id);
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "readPlanInformation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props2, plan, currentUser, translate, localLanguage, reader, start, end, status, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, plan = _this$props2.plan, currentUser = _this$props2.currentUser, translate = _this$props2.translate;
              localLanguage = localStorage.getItem("language");
              _context2.next = 4;
              return _this.props.getReaderParameters();

            case 4:
              reader = _this.props.reader;

              if (!(reader == null)) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return");

            case 7:
              start = new DateTime(plan.timeStart).getShortDate();
              end = new DateTime(plan.timeEnd).getShortDate();
              status = translate('Open');

              if (plan.status == 'PLANNING_CLOSED') {
                status = translate('closed');
              }

              if (plan.status == 'PLANNING_DRAFT') {
                status = translate('Draft');
              }

              data = {
                title: plan.title,
                chunks: [{
                  content: "<h3>\n\t\t\t\t\t\t".concat(translate('Plan information'), "\n\t\t\t\t\t</h3>"),
                  mimeType: "text/html"
                }, {
                  content: "\n\t\t\t\t\t\t".concat(translate('Plan is active between'), ":\n\t\t\t\t\t\t").concat(start, " - ").concat(end, " and the current status is: ").concat(status, "\n\t\t\t\t\t\t</br>\n\t\t\t\t\t"),
                  mimeType: "text/html"
                }, {
                  content: "\n\t\t\t\t\t\t".concat(translate('It belongs to the group named'), ":\n\t\t\t\t\t\t").concat(plan.section.title, "\n\t\t\t\t\t\t</br>\n\t\t\t\t\t"),
                  mimeType: "text/html"
                }]
              };
              ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                uiLang: localLanguage // Set immersive reader UI language to selected lang in Haldor Edu

              })["catch"](function (error) {
                console.error("error", error);
                trackImmersiveReaderError(error, currentUser.id);
              });

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (reRender, skipPrompt) {
      if (skipPrompt) {
        _this.setState({
          modalIsOpen: false
        });

        if (reRender) {
          _this.reload();
        }
      } else {
        if (reRender) {
          _this.props.getPlanDetails(_this.props.match.params.planId);
        }

        _this.setState({
          modalIsOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderPlanStatus", function () {
      if (_this.props.plan == null) {
        return null;
      }

      if (_this.props.plan.locked) {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-red"
        }, _this.props.translate('plan-is-processing'));
      }

      var status = _this.props.plan.status;
      var assessed = false;
      var isStudent = isUserStudent(_this.props.currentUser);

      if (_this.props.assessments != null && isStudent) {
        if (_this.props.assessments.length > 0) {
          assessed = true;
        }
      }

      if (assessed == false) {
        if (status === 'PLANNING_OPEN') {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-green"
          }, _this.props.translate('Open'));
        } else if (status === 'PLANNING_CLOSED') {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-red"
          }, _this.props.translate('closed'));
        } else if (status === 'PLANNING_DRAFT') {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-gray"
          }, _this.props.translate('Draft'));
        }
      }

      return /*#__PURE__*/React.createElement("span", {
        className: "dot dot-green"
      }, _this.props.translate('assessed'));
    });

    _defineProperty(_assertThisInitialized(_this), "printGoals", function () {
      var _this$props3 = _this.props,
          plan = _this$props3.plan,
          goals = _this$props3.goals;

      if (!plan || goals.length < 1) {
        return null;
      }

      if (plan.associatedGoals && plan.associatedGoals.length > 0) {
        return /*#__PURE__*/React.createElement("div", null, plan.associatedGoals.map(function (goal) {
          var foundGoal = goals.find(function (g) {
            return g.id == goal.goalId;
          });

          if (foundGoal) {
            return /*#__PURE__*/React.createElement("div", {
              key: "goal-".concat(foundGoal.id),
              style: {
                backgroundColor: foundGoal.colorCode
              },
              "data-tooltip": foundGoal.text,
              className: "goal-preview"
            }, foundGoal.title);
          }

          return null;
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderModals", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.modalIsOpen,
        onClose: _this.closeModal,
        title: _this.props.translate('edit-plan')
      }, /*#__PURE__*/React.createElement(PreschoolPlanningForm, {
        editView: true,
        onAbort: _this.closeModal.bind(_assertThisInitialized(_this))
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPrintButton", function () {
      var url = "/print/plan/".concat(_this.props.match.params.planId);

      if (getRootUrl() != '/') {
        url = "/print/planning-tab/".concat(_this.props.match.params.planId);
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          display: 'inline'
        },
        to: url
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Printer"
      }), _this.props.translate("printable-view"))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFields", function () {
      var _this$props4 = _this.props,
          plan = _this$props4.plan,
          translate = _this$props4.translate;

      if (plan == null) {
        return null;
      }

      if (plan.fields != null && plan.fields.length > 0) {
        return /*#__PURE__*/React.createElement("div", null, plan.fields.map(function (field, index) {
          // This is to be replaced with UI components later
          if (field.type == 'MULTILINETEXT') {
            return /*#__PURE__*/React.createElement("div", {
              key: "field-".concat(index),
              style: {
                marginTop: '1rem'
              }
            }, /*#__PURE__*/React.createElement("span", {
              className: "title"
            }, translate(field.title)), /*#__PURE__*/React.createElement(PostContent, null, field.content));
          }

          return null;
        }));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "planContent", function () {
      var plan = _this.props.plan;
      var isStudent = isUserStudent(_this.props.currentUser);
      var teacherOwnsPlan = false;

      if (_this.props.activeSection != null) {
        var _this$props$activeSec;

        teacherOwnsPlan = ((_this$props$activeSec = _this.props.activeSection.owners) === null || _this$props$activeSec === void 0 ? void 0 : _this$props$activeSec.find(function (owner) {
          return owner.userId == _this.props.currentUser.userId;
        })) != null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-plan single-task",
        key: plan.id
      }, isStudent || !teacherOwnsPlan ? null : _this.renderModals(), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-assignment-meta"
      }, plan.section.title)), /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          marginTop: 0
        }
      }, _this.props.translate('Status')), /*#__PURE__*/React.createElement("div", null, _this.renderPlanStatus()), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('information')), /*#__PURE__*/React.createElement(DateSpan, {
        start: plan.timeStart,
        end: plan.timeEnd
      }), _this.props.plan.status == 'PLANNING_DRAFT' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginTop: 5,
          display: 'block'
        }
      }, _this.props.translate('Draft')) : null), /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('tools')), isStudent || !teacherOwnsPlan || _this.state.loadingBlocks ? null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: _this.openModal
      }, _this.props.translate('Edit'))), isStudent || !teacherOwnsPlan || plan.isDeletable == false ? null : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: 5
        },
        onClick: _this.toggleDeletion
      }, _this.props.translate('Delete'))), _this.renderPrintButton(), !isStudent ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(CloneButton, {
        onClose: _this.reload,
        object: plan,
        type: "preschoolplanning"
      }, _this.props.translate('column-copy'))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Expandable, {
        title: _this.props.translate('Planning information'),
        open: true
      }, /*#__PURE__*/React.createElement("div", null, _this.props.services.immersiveReaderPlans ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: _this.readPlanInformation
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), _this.props.translate("immersive-reader"))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement(Bookmark, {
        referenceType: "PLAN",
        referenceId: plan.id
      })), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('goals')), _this.printGoals(), _this.renderFields(), _this.props.services.additionalAdjustments && !isStudent && _this.props.activeSection && _this.props.activeSection.owners.filter(function (ss) {
        return ss.id == _this.props.currentUser.id;
      }).length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: _this.props.translate("additional-adjustments")
      }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
        groupId: plan.sectionId
      }))) : null))), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both',
          marginTop: '2rem'
        }
      }), _this.props.blocks != null && !_this.state.loadingBlocks ? /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Expandable, {
        title: _this.props.translate('Content'),
        open: true
      }, _this.props.services.immersiveReaderPlans ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: _this.runImmersiveReader
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), _this.props.translate('immersive-reader'))) : null, /*#__PURE__*/React.createElement(BlockConsumer, {
        fields: _this.props.blocks
      }))) : /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Expandable, {
        title: _this.props.translate("Content"),
        open: true
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '3em'
        },
        className: "single-section-divider"
      }), isStudent == false && teacherOwnsPlan && _this.props.plan.students != null && _this.props.plan.students.length > 0 ? /*#__PURE__*/React.createElement(List, {
        title: _this.props.translate('students')
      }, /*#__PURE__*/React.createElement(UserPlanning, {
        items: _this.props.plan.students,
        planId: _this.props.match.params.planId,
        reload: _this.reload,
        allowStatus: true,
        printable: true
      })) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlanPosts, {
        sectionId: plan.section.id,
        planId: plan.id,
        section: _this.props.activeSection
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }));
    });

    _this.state = {
      modalIsOpen: false,
      loading: false,
      loadingBlocks: true
    };

    _this.closeModal.bind(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(PreschoolPlan, [{
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      } // Check if plan is null


      if (this.props.plan == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement("div", {
          className: "single-section left-side"
        }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '1rem 0'
          },
          className: "text--center color--meta weight--bold"
        }, this.props.translate('plan-has-been-deleted')))), /*#__PURE__*/React.createElement("div", {
          className: "single-actions right-side"
        }));
      }

      if (Object.keys(this.props.plan).length > 0) {
        return /*#__PURE__*/React.createElement("div", null, this.planContent());
      } else {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
    }
  }]);

  return PreschoolPlan;
}(Component);

function mapStateToProps(state) {
  return {
    plan: state.planning.active_plan,
    currentUser: state.user.currentUser,
    sections: state.sections.educationGroups,
    activeSection: state.planning.section,
    assessments: state.assessments.assessments,
    translate: translate(state.Languages.translations),
    goals: state.PreschoolGoals.preschoolGoals,
    reader: state.user.reader,
    services: state.Services.availableServices,
    blocks: state.Blocks.reference
  };
}

export default withRouter(connect(mapStateToProps, {
  getPlanDetails: getPlanDetails,
  addError: addError,
  deletePlan: deletePlan,
  getPlanSection: getPlanSection,
  fetch_preschoolgoals: fetch_preschoolgoals,
  setActivePlan: setActivePlan,
  setPageTitle: setPageTitle,
  getReaderParameters: getReaderParameters,
  getBlocksByReference: getBlocksByReference,
  clearBlocksOnReference: clearBlocksOnReference
})(PreschoolPlan));